import Modal from "@/components/common/modal";
import { Button } from "@elaniintc/goes-design-system";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

const EditConfirmationModal = ({ onConfirm, onCancel, isOpen }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Guardar cambios"
      description="¿Estás seguro de que deseas guardar los cambios?"
      modalContentClassName="w-full max-w-[520px]"
    >
      <div className="w-full flex justify-between gap-3 pt-8">
        <Button
          className="w-1/2"
          size="lg"
          type="button"
          variant="tertiary"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button className="w-1/2" size="lg" type="button" onClick={onConfirm}>
          Guardar
        </Button>
      </div>
    </Modal>
  );
};

export default EditConfirmationModal;
